import { TypeOrmModule } from "@nestjs/typeorm";
import { PointTypesEntity } from "./entities/point-type-entity";
import { Module } from "@nestjs/common";
import { PointTypeController } from "./point-type-controller";
import { PointTypeService } from "./point-type-service";
import { PointTypeRepo } from "./repositories/point-type-repo";

@Module({

    imports:[TypeOrmModule.forFeature([PointTypesEntity])],
    controllers:[PointTypeController],
    providers:[PointTypeService,PointTypeRepo]
})
export class PointTypeModule{}